import { Injectable } from '@angular/core';

import Decimal from 'decimal.js';

import { IBetslipState } from '../../../../../base/store/state';
import { IBetslip, ISlip } from '../../../../bet-generation/models';
import { SingleSlipType } from '../../../../bet-generation/slip-type';
import BetslipStakeConfigurationService from '../../../../stake/services/betslip-stake-configuration.service';
import { SlipValidationContext } from '../../../models/models';
import { RewardTokensContextGeneratorService } from './reward-tokens-context-generator.service';

@Injectable()
export class SlipContextGeneratorService {
    constructor(
        private stakeConfigService: BetslipStakeConfigurationService,
        private rewardTokensGenerator: RewardTokensContextGeneratorService,
    ) {}

    generateContext(slip: ISlip, betslip: IBetslip, state: IBetslipState): SlipValidationContext {
        return {
            maximumStake: this.getMaximumStake(betslip),
            rewardTokens: this.rewardTokensGenerator.generateContextForSlip(state.rewardTokens, state.types, slip),
        };
    }

    private getMaximumStake(betslip: IBetslip): Decimal | null {
        if (!this.stakeConfigService.maxStake) {
            return null;
        }

        const maximumStake = new Decimal(this.stakeConfigService.maxStake);

        return betslip.slips.every((s) => s.type instanceof SingleSlipType) ? maximumStake : maximumStake.div(betslip.slips.length);
    }
}
